<template>
  <div class="admin-app">
    <HeaderComponent />

    <!-- Main Content -->
    <div class="admin-container" dir="rtl">
      <div class="admin-content">
        <div class="admin-card">
          <!-- Login Form -->
          <div v-if="!isAuthenticated" class="login-section">
            <div class="login-header">
              <h2 class="login-title">تسجيل دخول المشرفين</h2>
              <div class="login-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                  <polyline points="10 17 15 12 10 7"></polyline>
                  <line x1="15" y1="12" x2="3" y2="12"></line>
                </svg>
              </div>
            </div>
            
            <form @submit.prevent="handleLogin" class="login-form">
              <div class="form-group">
                <label for="username">اسم المستخدم</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    v-model="username" 
                    id="username" 
                    required 
                    placeholder="أدخل اسم المستخدم"
                  />
                  <span class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </span>
                </div>
              </div>
              
              <div class="form-group">
                <label for="password">كلمة المرور</label>
                <div class="input-group">
                  <input 
                    type="password" 
                    v-model="password" 
                    id="password" 
                    required 
                    placeholder="أدخل كلمة المرور"
                  />
                  <span class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                  </span>
                </div>
              </div>
              
              <button type="submit" class="login-button">
                <span v-if="!loading">تسجيل الدخول</span>
                <span v-else class="button-spinner"></span>
              </button>
              
              <div v-if="errorMessage" class="error-message">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                {{ errorMessage }}
              </div>
            </form>
          </div>

          <!-- Admin Dashboard -->
          <div v-else class="dashboard-section">
            <div class="dashboard-header">
              <h2 class="dashboard-title">لوحة التحكم</h2>
              <button @click="logout" class="logout-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                تسجيل الخروج
              </button>
            </div>
            
            <div class="dashboard-grid">
              <div class="dashboard-card" @click="goTo('slots')">
                <div class="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <h3>إدارة المواعيد</h3>
                <p>إضافة، تعديل أو حذف المواعيد المتاحة</p>
              </div>
              
              <div class="dashboard-card" @click="goTo('data')">
                <div class="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                </div>
                <h3>متابعة الحجوزات</h3>
                <p>عرض وتعديل حجوزات الطلاب</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../../../public/global/headerComponent.vue';
import FooterComponent from '../../../public/global/footerComponent.vue';

export default {
  name: 'AdminPanel',
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      isAuthenticated: false,
      username: '',
      password: '',
      errorMessage: '',
      loading: false
    };
  },
  mounted() {
    this.checkAuthentication();
  },
  methods: {
    checkAuthentication() {
      this.isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';
    },
    async handleLogin() {
      this.loading = true;
      this.errorMessage = '';
      
      try {
        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 800));
        
        if (this.username === 'admin' && this.password === 'EOK##aiu25') {
          this.isAuthenticated = true;
          sessionStorage.setItem('isAuthenticated', 'true');
          
          // Check if there's an intended route
          const intendedRoute = sessionStorage.getItem('intendedRoute');
          if (intendedRoute) {
            sessionStorage.removeItem('intendedRoute');
            this.$router.push(intendedRoute);
          }
        } else {
          this.errorMessage = 'اسم المستخدم أو كلمة المرور غير صحيحة';
        }
      } catch (error) {
        this.errorMessage = 'حدث خطأ أثناء محاولة تسجيل الدخول';
      } finally {
        this.loading = false;
      }
    },
    goTo(page) {
      this.$router.push(`/adminpanel/${page}`);
    },
    logout() {
      this.isAuthenticated = false;
      sessionStorage.removeItem('isAuthenticated');
      this.username = '';
      this.password = '';
    },
  },
};
</script>

<style scoped>
/* Base Styles */
.admin-app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f8f9fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.admin-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}

.admin-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* Admin Card */
.admin-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

/* Login Section */
.login-section {
  padding: 2.5rem;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
}

.login-title {
  color: #0f106c;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.login-icon {
  color: #c42326;
  margin-bottom: 1rem;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
}

.input-group {
  position: relative;
}

.input-group input {
  width: 100%;
  padding: 0.75rem 2.5rem 0.75rem 2.5rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.input-group input:focus {
  outline: none;
  border-color: #0f106c;
  box-shadow: 0 0 0 3px rgba(15, 16, 108, 0.1);
}

.input-icon {
  position: absolute;
  right: 1rem;
  
  top: 50%;
  transform: translateY(-50%);
  color: #777;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #c42326;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
  margin-top: 1rem;
}

.login-button:hover {
  background-color: #a81b1b;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc3545;
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #f8d7da;
  border-radius: 8px;
  font-size: 0.9rem;
}

/* Dashboard Section */
.dashboard-section {
  padding: 2rem;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}

.dashboard-title {
  color: #0f106c;
  font-size: 1.8rem;
  font-weight: 700;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #c42326;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
}

.logout-button:hover {
  color: #a81b1b;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.dashboard-card {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-color: #c42326;
}

.card-icon {
  color: #c42326;
  margin-bottom: 1rem;
}

.dashboard-card h3 {
  color: #0f106c;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
}

.dashboard-card p {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0;
}

/* Button Spinner */
.button-spinner {
  display: inline-block;
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .admin-container {
    padding: 1rem;
  }
  
  .login-section {
    padding: 1.5rem;
  }
  
  .login-title {
    font-size: 1.5rem;
  }
  
  .dashboard-section {
    padding: 1.5rem;
  }
  
  .dashboard-title {
    font-size: 1.5rem;
  }
  
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .login-section {
    padding: 1rem;
  }
  
  .login-title {
    font-size: 1.3rem;
  }
  
  .dashboard-section {
    padding: 1rem;
  }
  
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .logout-button {
    align-self: flex-end;
  }
}

/* Animation for better UX */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-form {
  animation: fadeIn 0.5s ease;
}

.dashboard-grid {
  animation: fadeIn 0.5s ease;
}
</style>